// extracted by mini-css-extract-plugin
export default {"container":"style_container__N6zsP","left":"style_left__Oq5S1","right":"style_right__hy5gp","text":"style_text__TBFAs"};